export type VolumeIntersectionQueryType =
  | 'clearAndSelect'
  | 'select'
  | 'deselect';

export type VolumeIntersectionQueryMode = 'exclusive' | 'inclusive';
